import { temAcesso } from '@/shared/auth/temAcesso'

const Pleitos = () => import('./Pleitos.vue')
const Detalhes = () => import('./PleitosDetalhar.vue')
const PleitoForm = () => import('../componentes/PleitoForm.vue')

export default {
    path: 'pleitos/financeiro',
    name: 'Pleitos_Financeiro',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('PLEITOS-FINAN-00')) {
            next()
        }
    },
    children: [
        {
            path: '/pleitos/financeiro',
            name: 'Pleitos_Financeiro',
            component: Pleitos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-FINAN-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/financeiro/:pleitoId',
            name: 'Pleitos_Financeiro_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-FINAN-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/inserir',
            name: 'Pleitos_Financeiro_Inserir',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-FINAN-01')) {
                    next();
                }
            }
        },
        {
            path: '/pleitos/atualizar/:pleitoId',
            name: 'Pleitos_Financeiro_Atualizar',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-FINAN-01')) {
                    next();
                }
            }
        }, 
    ]
}
